import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {conditional} from '../../../util/conditional';
import {selectIsOnesided, selectIsSingle, selectLdt1, selectLdt2, selectMountingInstruction} from '../../../selectors';

@customElement('page-data-and-text')
export class PageDataAndText extends LitElement {

	static styles = css`
	.polar {
		width: 50%;
	  }
	  .page-container {
		  display: flex;
		  margin: var(--specsheet-medium-gap) var(--specsheet-large-gap);

	  }

	  .diagrams {
		  width: 45%;
		  padding-left: var(--specsheet-large-gap);
	  }

	  .description {
		  font: var(	--font-specsheet-light);
		  width: 50%;
	  }

	  .downloads {
		  margin-top: 50px;
		  font: var(--font-specsheet-bold);
	  }

	  a {
		  color: #000;
	  }

	  p {
		  font: var(--font-specsheet-light);
	  }

	  p span {
		  font: var(--font-specsheet-bold);
	  }
	  .image {
		  margin-bottom: 60px;
	  }

	  .sketch  {
		  height: 230px;
	  }

	  .title {
		  color: var(--color-black);
		  font: var(--font-specsheet-print-light);
		  font-size: var(--font-size-sections);
		  font: var(--font-specsheet-bold);
	  }

	  .tender-text {
		margin-top: var(--specsheet-small-gap);
	  }

	  @media print {
		  .page-container {
			  display: flex;
			  width: 100vw;
			  margin-top: 10vw;
		  }
		  .title {
			  color: var(--color-black);
			  font-size: var(--font-size-sections);
			  font: var(--font-specsheet-print-bold);
		  }
		  .diagrams {
			  width: 40vw;
			  padding-left: 0px;
		  }

		  .description {
			  font: var(--font-specsheet-print-light);
			  width: 46vw;
		  }

		.image {
			margin-bottom: var(--specsheet-large-gap);
		}
	  }

	`;
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.decisions = state.decisions.data;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}
	c(id) {
		return conditional(this.decisions, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		return html`

		<div class="page-container">
			<div class="diagrams">
				<div class="image">
					<polar-diagram></polar-diagram>
				</div>
			</div>

			<div class="description">
				<div slot="content">
					<strong><trans-label class="title" slot="title" key="LE_LuminousFlux_OperatingTime" context="D"></trans-label><strong>
					<div slot="content">
						<llmf-table></llmf-table>
					</div>

					<div slot="content" class="tender-text">
						<tender-text></tender-text>
					</div>

				</div>
			</div>



	</div>

		`;
	}
}
